import React from 'react';
import LineChart from './LineChart';
import BarChart from './BarChart';
import PieChart from './PieChart';
import './Charts.css';

const DonationAnalytics = ({ data = {} }) => {
  const {
    donationTrends = [{ timestamp: new Date(), value: 0 }],
    donationsByType = [
      { type: 'One-time', amount: 0, percentage: 0 },
      { type: 'Monthly', amount: 0, percentage: 0 },
      { type: 'Annual', amount: 0, percentage: 0 }
    ],
    donorRetention = {
      newDonors: 0,
      returningDonors: 0,
      retentionRate: '0%'
    },
    averageDonation = '$0',
    totalDonations = '$0',
    donorGrowth = 0
  } = data;

  return (
    <div className="donation-analytics">
      <h2>Donation Analytics</h2>
      <div className="charts-grid">
        <div className="chart-container">
          <h3>Donation Trends</h3>
          <LineChart 
            data={donationTrends}
            xAxis="Date"
            yAxis="Amount"
          />
        </div>

        <div className="chart-container">
          <h3>Donations by Type</h3>
          <PieChart 
            data={donationsByType.map(type => ({
              label: type.type,
              value: type.amount,
              percentage: type.percentage
            }))}
          />
        </div>

        <div className="metrics-overview">
          <div className="metric-card">
            <h4>Total Donations</h4>
            <p>{totalDonations}</p>
          </div>
          <div className="metric-card">
            <h4>Avg. Donation</h4>
            <p>{averageDonation}</p>
          </div>
          <div className="metric-card">
            <h4>Donor Growth</h4>
            <p>{donorGrowth}%</p>
          </div>
          <div className="metric-card">
            <h4>Retention Rate</h4>
            <p>{donorRetention.retentionRate}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DonationAnalytics; 